import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from "@material-ui/core/Grid";
import translate from '../other/translate.json';
import clsx from 'clsx';
import config from '../other/config';
const { serverAPI } = config;

const CustomTypography = withStyles((theme) => ({
  h1: {
    fontSize: '40px',
    lineHeight: '48px',
    fontWeight: '500',
    color: '#24262A'
  },

  body1: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: '400',
    color: '#8987A2'
  },

  gutterBottom: {
    marginBottom: 20
  },
}))(Typography);

export default function Cookie(props) {
  const classes = useStyles();
  const language = localStorage.getItem('language') || 'Ru'

  return (
    language === 'Ru'
      ?
      <Grid container>
        <CustomTypography variant="h1" gutterBottom>О компании</CustomTypography>

        <CustomTypography variant="body1" gutterBottom>АО «Центр Финансовых Технологий» (АО «ЦФТ») – российский разработчик  программного обеспечения для финансового сектора, работает на рынке с 1991 года.</CustomTypography>

        <CustomTypography variant="body1" gutterBottom>ЦФТ специализируется на  проектировании, разработке и тиражировании высокотехнологичных решений, оказании услуг ИТ-аутсорсинга. Продуктовая линейка ЦФТ представлена продуктами для core-банкинга, осуществления всех видов банковской деятельности.</CustomTypography>

        <CustomTypography variant="body1" gutterBottom>Программные продукты ЦФТ используют в своей деятельности крупные и средние банки, госкорпорации, страховые компании др.</CustomTypography>
        <CustomTypography variant="body1" gutterBottom>Решения ЦФТ входят в Единый реестр отечественного ПО.  Среди них  банковский информационный комплекс  <a href="https://reestr.digital.gov.ru/reestr/303817/?sphrase_id=2118121" className={classes.LinkType2} target="_blank" rel="nofollow noopener">ЦФТ-Банк</a>, система
          <a href="https://reestr.digital.gov.ru/reestr/305127/?sphrase_id=2118121" className={classes.LinkType2} target="_blank" rel="nofollow noopener"> ЦФТ-Ритейл банк (РБС)</a>, система
          <a href="https://reestr.digital.gov.ru/reestr/855484/?sphrase_id=2118121" className={classes.LinkType2} target="_blank" rel="nofollow noopener"> ЦФТ-AML</a>, система
          <a href="https://reestr.digital.gov.ru/reestr/389201/?sphrase_id=2118121" className={classes.LinkType2} target="_blank" rel="nofollow noopener"> ЦФТ-Сервис Сьют (Service Suite)</a> </CustomTypography>
      </Grid>
      :
      <React.Fragment>
        <CustomTypography variant="h1" gutterBottom>About Us</CustomTypography>
        
        <Grid container>
          <CustomTypography variant="body1" gutterBottom>Center of Financial Technologies JSC (CFT JSC) is a Russian vendor of software for the financial sector and has been on the market since 1991.</CustomTypography>

          <CustomTypography variant="body1" gutterBottom>CFT specializes in design, development and replication of high-tech solutions and provision of IT outsourcing services. The CFT product line includes products for core-banking as well as all types of banking activities.</CustomTypography>

          <CustomTypography variant="body1" gutterBottom>The software products of CFT are used by large and medium-sized banks, state corporations, insurance companies, etc.</CustomTypography>
          <CustomTypography variant="body1" gutterBottom>CFT solutions are included in the Unified Register of Domestic Software. Among them are    <a href="https://reestr.digital.gov.ru/reestr/303817/?sphrase_id=2118121" className={classes.LinkType2} target="_blank" rel="nofollow noopener">the CFT-Bank</a>banking information complex, система
            <a href="https://reestr.digital.gov.ru/reestr/305127/?sphrase_id=2118121" className={classes.LinkType2} target="_blank" rel="nofollow noopener"> the CFT-Retail Bank (RBS)</a> system,
            <a href="https://reestr.digital.gov.ru/reestr/855484/?sphrase_id=2118121" className={classes.LinkType2} target="_blank" rel="nofollow noopener"> the CFT-AML</a>system and
            <a href="https://reestr.digital.gov.ru/reestr/389201/?sphrase_id=2118121" className={classes.LinkType2} target="_blank" rel="nofollow noopener"> the CFT-Service Suite</a> system.</CustomTypography>
        </Grid>
      </React.Fragment>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: '100%',
    backgroundColor: '#F6F6FB',
    borderRadius: 16,
    boxShadow: 'none',
    padding: 24,
    height: 'fit-content',

    [theme.breakpoints.down(696)]: {
      padding: 0,
      backgroundColor: 'transparent',
    }
  },

  LinkType2: {
    // fontFamily: 'Cera CY',
    // fontStyle: 'normal',
    // fontWeight: 'normal',
    // fontSize: '16px',
    // lineHeight: '24px',
    // color: '#24262A',

    // '& * > a': {
    color: '#24262A !important',
    textDecoration: 'none',
    borderBottom: '1px solid rgba(0, 0, 0, 0.4)',

    '&:hover': {
      color: '#2050FF !important',
      textDecoration: 'none',
      borderBottom: '1px solid #2050FF',
    }
  }
}));